import { useAsyncStateWithIsLoading } from "@/utils/hooks";
import { createDataTable } from "@/components/DataTable";
import React, { useState } from 'react';
import { ElectricitySupplierOffer } from "@/types";
import { CustomLink, LoadingIndicator } from "@ygtechnologies/bygr-frontend-component-library";
import { deleteElectricitySupplierOffer, getElectricitySupplierOffers } from "@/services/serviceProvider";
import { faArrowUpArrowDown, faPlus } from "@fortawesome/pro-light-svg-icons";
import ElectricitySupplierReorderDialog from "./ElectricitySupplierReorderDialog";
import { Link } from 'react-router-dom';
import { Button, ConfirmButton } from '@ygtechnologies/rubus-ui';

const DataTable = createDataTable<ElectricitySupplierOffer>();

const ElectricitySupplierTable : React.FC<{}> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('title'));
    const [reorderModalOpen, setReorderModalOpen] = useState(false);
    const [data, , reload, isLoading] = useAsyncStateWithIsLoading(() => getElectricitySupplierOffers(tableState), [tableState], null);

    if (!data) {
        return <LoadingIndicator />;
    }

    const deleteOffer = async (id: number) => {
        await deleteElectricitySupplierOffer(id);
        reload();        
    }

    return (
        <div>
            <h2>Electricity Supplier</h2>
            <DataTable
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                toolbarActions={
                    <>
                        <Button size="sm" variant="primary" onClick={() => setReorderModalOpen(true)} icon={faArrowUpArrowDown}>
                            Edit Sort Order
                        </Button>
                        <Button as={Link} to="/electricity-suppliers/0" size="sm" variant="primary" icon={faPlus}>
                            Create offer
                        </Button>
                    </>
                }
                className="table style-3">
                <DataTable.Column
                    header="Title"
                    field="title"
                    sortable
                    renderer={({ row, value }) => {
                        return <CustomLink to={`/electricity-suppliers/${row.id}`}>{value}</CustomLink>;
                    }}
                />
                <DataTable.Column header="Supplier" field="supplier" />
                <DataTable.Column header="Name of offer" field="highlightedTitle1" />
                <DataTable.Column
                    header="Is Company offer"
                    field="isCompanyOffer"
                    renderer={({ value }) => (value ? 'Company' : 'Private')}
                />
                <DataTable.Column header="Sort Order" field="sortOrder" />
                <DataTable.Column
                    header=""
                    field="id"
                    renderer={({ value }) => (
                        <ConfirmButton
                            size="xs"
                            dialogTitle="Confirm"
                            dialogBody="Are you sure?"
                            variant="danger"
                            confirmButton={{ variant: 'danger' }}
                            loading={isLoading}
                            onConfirm={() => deleteOffer(value)}>
                            Delete
                        </ConfirmButton>
                    )}
                />
            </DataTable>

            <ElectricitySupplierReorderDialog
                offers={data.items}
                onAccept={reload}
                onClose={() => setReorderModalOpen(false)}
                show={reorderModalOpen}
            />
        </div>
    );
};

export default ElectricitySupplierTable;
